export const en = {
    assistant_for: 'Assistant for',
    assistant_required: 'Assistant is required',
};
